var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: _vm.classes,
    attrs: {
      "aria-label": _vm.accessibilityLabel || 'Pagination'
    }
  }, [(_vm.previousURL) ? _c('polaris-unstyled-link', {
    staticClass: "Polaris-Pagination__Button",
    attrs: {
      "url": _vm.previousURL,
      "aria-label": "Previous"
    },
    on: {
      "mouseup": _vm.handleMouseUp
    }
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.arrowLeft
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.previousURL) ? _c('polaris-button', {
    staticClass: "Polaris-Pagination__Button",
    attrs: {
      "disabled": !_vm.hasPrevious
    },
    on: {
      "click": _vm.onPrevious,
      "mouseup": _vm.handleMouseUp
    }
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.arrowLeft
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nextURL) ? _c('polaris-unstyled-link', {
    staticClass: "Polaris-Pagination__Button",
    attrs: {
      "url": _vm.nextURL,
      "aria-label": "Next"
    },
    on: {
      "mouseup": _vm.handleMouseUp
    }
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.arrowRight
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.nextURL) ? _c('polaris-button', {
    staticClass: "Polaris-Pagination__Button",
    attrs: {
      "disabled": !_vm.hasNext
    },
    on: {
      "click": _vm.onNext,
      "mouseup": _vm.handleMouseUp
    }
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.arrowRight
    }
  })], 1) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-89a2968e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89a2968e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPagination.vue
// module id = 343
// module chunks = 0